import type { DisplayInnerShadow } from ".";

export function getScrollPercentage(
  scrollTop: number,
  scrollHeight: number,
  offsetHeight: number
): number | null {
  if (offsetHeight < scrollHeight) {
    return Math.max(
      0,
      Math.floor(scrollTop) / Math.floor(scrollHeight - offsetHeight)
    );
  }
  return null;
}

export function determineInnerShadowToDisplay(
  scrollTop: number,
  scrollHeight: number,
  offsetHeight: number
): DisplayInnerShadow {
  const percentage = getScrollPercentage(scrollTop, scrollHeight, offsetHeight);
  if (percentage !== null) {
    if (percentage > 0) {
      if (percentage < 1) {
        return "BOTH";
      } else {
        return "TOP";
      }
    } else if (percentage < 1) {
      return "BOTTOM";
    }
  }
  return null;
}
